import React from 'react';
import PropTypes from 'prop-types';

const Highlight = ({ children, clear }) => (
  <div className={`highlight${clear ? ' highlight--clear' : ''}`}>
    {children}
  </div>
);

Highlight.propTypes = {
  children: PropTypes.node,
  clear: PropTypes.bool
};

Highlight.defaultProps = {
  children: null,
  clear: false
};

export default Highlight;



// WEBPACK FOOTER //
// ./src/components/Common/Highlight/Highlight.js